import { Box, Typography } from '@mui/material';
import { PurrformanceChartType } from '../PurrformanceCharts';

import { AppTooltip } from '../../../common/Tooltip';

export const PurrformanceChartTooltip = ({ type }: { type: PurrformanceChartType }) => {
    const getTexts = () => {
        switch (type) {
            case PurrformanceChartType.CLASH_WINS: {
                return (
                    <span>
                        Each victory claimed by a clan purr-sonality gets your clan higher up this chart that shows the{' '}
                        <b style={{ fontFamily: 'AvenirNext600' }}>
                            total number of victories gained by all clan members.
                        </b>{' '}
                        Keep those wins coming, and watch your clan reign the leaderboard!
                    </span>
                );
            }

            case PurrformanceChartType.HIGHEST_WIN_RATE: {
                return (
                    <span>
                        This chart reflects the{' '}
                        <b style={{ fontFamily: 'AvenirNext600' }}>
                            average win rates of clan members in duels and Isle Clashes.
                        </b>{' '}
                        The better the performance in both PvP modes, the higher a clan climbs the leaderboard!
                    </span>
                );
            }
            case PurrformanceChartType.WLKN_GAINED: {
                return (
                    <span>
                        This chart tracks the total{' '}
                        <b style={{ fontFamily: 'AvenirNext600' }}>WLKN earned by all clan members in PvP duels.</b> The
                        greater the haul, the higher your clan climbs!
                    </span>
                );
            }
        }
    };

    return (
        <AppTooltip
            title={
                <Box
                    sx={{
                        padding: '30px',
                    }}
                >
                    <Typography
                        sx={{
                            color: '#0F0E0E',
                            fontFamily: 'AvenirNext400',
                            fontSize: '16px',
                        }}
                    >
                        {getTexts()}
                    </Typography>
                </Box>
            }
        ></AppTooltip>
    );
};
